module.exports = __webpack_public_path__ + "img/xiao.f2277028.png";